import { render } from "./Setting.vue?vue&type=template&id=f661ad14&scoped=true"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"

import "./Setting.vue?vue&type=style&index=0&id=f661ad14&lang=less&scoped=true"

import exportComponent from "/Users/Shared/Previously Relocated Items/Security/data/www/solo/CyReport/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f661ad14"]])

export default __exports__